import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { FixNumber } from "../common/orders";
import { getCurrencyShorthand } from "../providers/StationProvider";
import { OrderEnumsLists } from "../common/constants";

export default function useOrderMissionDetailsColumns() {
  const { t } = useTranslation();

  return useMemo(() => {
    return [
      {
        field: "number",
        type: "number",
        headerName: t("entity:order:number"),
        flex: 0
      },
      {
        field: "missionNumber",
        type: "number",
        headerName: t("common:tables:mission"),
        flex: 0
      },
      {
        field: "customer.name",
        headerName: t("entity:order:customer"),
        valueGetter: (_, row) => row.customer?.name || "-",
        minWidth: 160,
        flex: 0.5,
      },
      {
        field: "customer.organizationNumber",
        headerName: t("entity:contact:organizationNumber"),
        valueGetter: (_, row) => row.customer?.organizationNumber || "-",
        minWidth: 160,
        flex: 0.5,
      },
      {
        field: "mission.target.carDetails.registration||mission.target.boatDetails.registration",
        headerName: t("entity:mission:target:registration"),
        valueGetter: (_, row) => {
          const type = row.mission?.target?.type;
          const target = type === 1 ? row.mission?.target?.carDetails : (type === 2 ? row.mission.target.boatDetails : null);
          return target?.registration || "-";
        },
        minWidth: 100,
        flex: 0.5,
        sortable: false
      },
      {
        field: "mission.actors.requester.name||mission.actors.owner.name",
        headerName: t("common:tables:requester"),
        valueGetter: (_, row) => (row.mission?.actors?.ownerIsNotRequester ? row.mission?.actors?.requester?.name : row.mission?.actors?.owner?.name) || "-",
        flex: 1,
        minWidth: 120,
        sortable: false
      },
      {
        field: "payment.method",
        type: "singleSelect",
        minWidth: 160,
        headerName: t("entity:order:payment:method"),
        valueGetter: (_, row) => row.payment.method,
        valueFormatter: (value) => t(`order:enums:paymentMethod:${OrderEnumsLists.PaymentMethod[value]}`),
        valueOptions: OrderEnumsLists.PaymentMethod.map((_,i) => ({
          value: i,
          label: t(`order:enums:paymentMethod:${OrderEnumsLists.PaymentMethod[i]}`),
          type: "number"
        })),
      },
      {
        field: "payment.calculatedTotal.value",
        type: "number",
        entityType: "decimal",
        headerName: t("entity:order:payment:calculatedTotal"),
        valueGetter: (_, row) => Number(row.payment.calculatedTotal?.value || "0"),
        valueFormatter: (value) => FixNumber(value),
        renderCell: (params) => `${FixNumber(params.row.payment.calculatedTotal?.value)} ${getCurrencyShorthand(t, params.row.payment.calculatedTotal?.currency)}`,
        minWidth: 120
      },
      {
        field: "deductible.price.value",
        type: "number",
        entityType: "decimal",
        headerName: t("entity:order:deductible"),
        valueGetter: (_, row) => Number(row.deductible?.price?.value || "0"),
        valueFormatter: (value) => FixNumber(value),
        renderCell: (params) => params.row.deductible ? `${FixNumber(params.row.deductible?.price?.value)} ${getCurrencyShorthand(t, params.row.deductible?.price?.currency)}` : "-",
        minWidth: 120
      },
      {
        field: "payment.sender.name",
        headerName: t("entity:order:sender"),
        valueGetter: (_, row) => row.payment.sender?.name || "-",
        minWidth: 160,
        flex: 0.5
      },
      {
        field: "mission.actors.contract.agreement.name",
        headerName: t("entity:agreement:type"),
        valueGetter: (_, row) => row.mission?.actors?.contract?.agreement?.name || "-",
        minWidth: 160,
        flex: 0.5
      },
      {
        field: "comment",
        headerName: t("entity:order:internalComment"),
        valueGetter: (_, row) => row.comment || "-",
        minWidth: 160,
        flex: 0.5
      },
    ]
  }, [t]);
}